var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInbox = function SvgInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.7 32.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 8.9C18.6 3.6 10.5 2.9 5 7.4 2.4 9.6.7 12.7.5 16.1c-.3 3.4.7 6.7 2.9 9.4l-.9 5.2v.2c0 .7.6 1.3 1.4 1.3.2 0 .4 0 .6-.1l4.7-2.6c4.2 1.5 9 .6 12.4-2.4 2.6-2.2 4.3-5.3 4.5-8.7.4-3.5-.7-6.8-2.9-9.5zM6.1 25.3c0-.4-.1-.8-.4-1.1C4 22.4 3 19.9 3 17.3 3 11.6 7.6 7 13.3 7c1.2 0 2.4.2 3.8.7 5.2 2.1 7.8 8.1 5.8 13.4-1 2.5-2.9 4.5-5.4 5.6-2.5 1.1-5.3 1.1-7.8.1-.3-.1-.7-.1-1.1 0l-2.8 1.6.3-3.1z"
  })));
};
export default SvgInbox;